import { useTranslation } from 'react-i18next';
import { Box, ButtonGroup, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { LANG_STORAGE_KEY } from '../../utils/languageDetection';

// Each entry: mobile active color + desktop active color (chosen to contrast the gradient at top-right)
const colorsByJurisdiction = {
  tx: { mobileActive: 'var(--tx-secondary)', desktopActive: 'var(--tx-primary)', desktopActiveText: '#000000', desktopInactiveText: '#ffffff' },
  mi: { mobileActive: 'var(--mi-primary)',   desktopActive: 'var(--mi-primary)',   desktopActiveText: '#ffffff', desktopInactiveText: '#000000' },
  nj: { mobileActive: 'var(--nj-secondary)', desktopActive: 'var(--nj-secondary)', desktopActiveText: '#ffffff', desktopInactiveText: '#ffffff' },
  wv: { mobileActive: 'var(--wv-primary)',   desktopActive: 'var(--wv-secondary)', desktopActiveText: '#ffffff', desktopInactiveText: '#ffffff' },
};

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const { pathname } = useLocation();
  const currentLang = i18n.language;

  if (pathname === '/') return null;

  const segment = pathname.split('/')[1] || 'tx';
  const { mobileActive, desktopActive, desktopActiveText, desktopInactiveText } =
    colorsByJurisdiction[segment] || colorsByJurisdiction.tx;

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    localStorage.setItem(LANG_STORAGE_KEY, lng);
  };

  const buttonSx = isActive => ({
    backgroundColor: isActive ? mobileActive : 'transparent',
    color: isActive ? '#ffffff' : '#000000',
    borderColor: mobileActive,
    minWidth: 44,
    minHeight: 44,
    fontSize: '0.75rem',
    '@media (min-width:600px)': {
      backgroundColor: isActive ? desktopActive : 'transparent',
      color: isActive ? desktopActiveText : desktopInactiveText,
      borderColor: desktopActive,
      minWidth: 'unset',
      minHeight: 'unset',
      fontSize: '0.8125rem',
    },
  });

  return (
    <ButtonGroup
      sx={{ position: 'fixed', top: 8, right: 8, zIndex: 9999 }}
      aria-label='language selector'
    >
      <Button
        variant={currentLang === 'en' ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('en')}
        aria-pressed={currentLang === 'en'}
        sx={buttonSx(currentLang === 'en')}
      >
        <Box component='span' sx={{ display: { xs: 'none', sm: 'inline' } }}>
          {t('language.en')}
        </Box>
        <Box component='span' sx={{ display: { xs: 'inline', sm: 'none' } }}>
          EN
        </Box>
      </Button>
      <Button
        variant={currentLang === 'es' ? 'contained' : 'outlined'}
        onClick={() => changeLanguage('es')}
        aria-pressed={currentLang === 'es'}
        sx={buttonSx(currentLang === 'es')}
      >
        <Box component='span' sx={{ display: { xs: 'none', sm: 'inline' } }}>
          {t('language.es')}
        </Box>
        <Box component='span' sx={{ display: { xs: 'inline', sm: 'none' } }}>
          ES
        </Box>
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSelector;
